var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_611",
    "data-name": "Groupe 611",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29.555,
    height: 42.246,
    viewBox: "0 0 29.555 42.246",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_537",
    "data-name": "Trac\\xE9 537",
    d: "M0-16.7H29.555V-58.948H0Z",
    transform: "translate(0 58.948)",
    fill: "#e30613"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_610",
    "data-name": "Groupe 610",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_609",
    "data-name": "Groupe 609",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_536",
    "data-name": "Trac\\xE9 536",
    d: "M-5.628-6.419a18.563,18.563,0,0,0-11.49,3.545l.8-12.405H7.464v-7.374H-16.889L-18.262-2.131l.687.743c3.029-2.287,5.831-3.373,8.746-3.373,5.545,0,8.575,4.173,8.575,11.434,0,7.66-3.43,11.891-8.232,11.891a5.49,5.49,0,0,1-2.173-.458L-19.347,6.158h-.515V16.734A39.582,39.582,0,0,0-5.8,19.592c9.318,0,15.492-5.145,15.492-13.091,0-7.775-6.06-12.92-15.321-12.92",
    transform: "translate(19.862 22.654)",
    fill: "#e30613"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon5);
export default __webpack_public_path__ + "static/media/icon-5.69214b7a5f5216095a015ea12b1f8a02.svg";
export { ForwardRef as ReactComponent };